import { Button, Modal, FormGroup, Label, Input, ModalHeader, ModalBody, ModalFooter, Alert } from 'reactstrap';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import QRCode from './mfaQRCode';
class MFAModal extends Component {
  componentDidMount() {
    /**
     * If we haven't loaded or the secret has been cleared,
     * generate a new one.
     */
    // eslint-disable-next-line react/destructuring-assignment
    if (!this.props.secret || this.props.secret.length === 0) {
      // eslint-disable-next-line react/destructuring-assignment
      this.props.createNewSecret();
    }
  }
  render() {
    const _this$props = this.props,
      username = _this$props.username,
      customer = _this$props.customer,
      secret = _this$props.secret,
      showModal = _this$props.showModal,
      error = _this$props.error,
      onClose = _this$props.onClose,
      onChange = _this$props.onChange,
      onSave = _this$props.onSave,
      mfaEnabled = _this$props.mfaEnabled,
      pins = _this$props.pins;
    const firstPin = pins.firstPin,
      secondPin = pins.secondPin;
    const onFirstPinChange = event => onChange('firstPin', event.target.value);
    const onSecondPinChange = event => onChange('secondPin', event.target.value);
    const onKeyDown = e => {
      if (e.keyCode === 13) {
        onSave();
      }
    };
    const saveSecret = () => onSave();
    return /*#__PURE__*/React.createElement(Modal, {
      isOpen: showModal
    }, /*#__PURE__*/React.createElement(ModalHeader, null, "Your New MFA Secret"), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement("h3", null, "Please use an authentication app to scan this QR Code and test your secret."), /*#__PURE__*/React.createElement("div", {
      className: "qrCodeContainer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "qrCode t-ss-qr-code-image"
    }, /*#__PURE__*/React.createElement(QRCode, {
      username: username || 'unknown-user',
      customer: customer,
      secret: secret
    })), /*#__PURE__*/React.createElement("div", {
      className: "qrCodePinInputs"
    }, /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, null, "MFA Pin 1"), /*#__PURE__*/React.createElement(Input, {
      id: "mfaPin1",
      type: "text",
      value: firstPin,
      placeholder: "First Pin",
      onChange: onFirstPinChange,
      className: "t-ss-mfa-pin-1 tqc-control"
    })), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, null, "MFA Pin 2"), /*#__PURE__*/React.createElement(Input, {
      id: "mfaPin2",
      type: "text",
      value: secondPin,
      placeholder: "Second Pin",
      onChange: onSecondPinChange,
      onKeyDown: onKeyDown,
      className: "t-ss-mfa-pin-2 tqc-control"
    }))))), /*#__PURE__*/React.createElement("p", null, "Authentication apps are available from the iTunes App Store and Google Play"), /*#__PURE__*/React.createElement(Alert, {
      className: "t-ss-alert-error",
      color: "danger",
      isOpen: typeof error === 'string'
    }, error)), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
      onClick: onClose,
      className: "t-ss-cancel tqc-control"
    }, "Cancel MFA ", mfaEnabled ? 'Reset' : 'Setup'), /*#__PURE__*/React.createElement(Button, {
      className: "t-ss-enable tqc-control",
      onClick: saveSecret
    }, "Enable MFA & Save")));
  }
}
MFAModal.defaultProps = {
  error: null,
  username: 'unknown-user'
};
MFAModal.propTypes = {
  error: PropTypes.string,
  createNewSecret: PropTypes.func.isRequired,
  username: PropTypes.string,
  customer: PropTypes.string.isRequired,
  secret: PropTypes.string.isRequired,
  showModal: PropTypes.bool.isRequired,
  mfaEnabled: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  pins: PropTypes.shape({
    firstPin: PropTypes.string,
    secondPin: PropTypes.string
  }).isRequired
};
export default MFAModal;